import React from "react";
import { colors } from "shared/ui/colors";
import { HeaderContent } from '.';

const NoContextHeader = (props) => {
  return <HeaderContent siteArea="generic" color={colors.black} {...props} />
};

export default NoContextHeader;
